/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Map_LocationInputs */

const cs_enum_map_location = /** @type {(inputs: Enum_Map_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapa`)
};

const en_enum_map_location = /** @type {(inputs: Enum_Map_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map`)
};

/**
* | output |
* | --- |
* | "Map" |
*
* @param {Enum_Map_LocationInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_map_location = /** @type {((inputs?: Enum_Map_LocationInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Map_LocationInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_map_location(inputs)
	return cs_enum_map_location(inputs)
});